import React, { useState, useEffect, useMemo } from 'react';
import { 
  Plus, X, Briefcase, MapPin, IndianRupee, Phone, Clock, 
  Users, CheckCircle, XCircle, Building, Search, AlertCircle, PhoneCall,
  Volume2, VolumeX, HelpCircle, PlayCircle, Edit, Trash2
} from 'lucide-react';
import { useSmartGuide } from './useSmartGuide';
import Modal from '../../ui/Modal';
import ConfirmModal from '../../ui/ConfirmModal';

const API_BASE = 'https://mukadampro.shirpur.store';

// --- INJECT CUSTOM ANIMATION STYLES FOR SMART GUIDE ---
const styleTag = document.createElement("style");
styleTag.innerHTML = `

/* 🚀 PERFORMANCE, SMOOTHNESS & PREMIUM SCROLLBAR CSS 🚀 */
* { -webkit-tap-highlight-color: transparent; scroll-behavior: smooth; } 
body { 
   -webkit-font-smoothing: antialiased; 
   -moz-osx-font-smoothing: grayscale; 
   overscroll-behavior-y: none; 
   zoom: 0.95 !important;
   font-size: 14px; /* 🎯 FIX: !important को हटाकर सिर्फ मुख्य बॉडी पर सेट किया ताकि छोटे लेबल्स अपनी सही साइज़ में दिखें */
}

@keyframes pulseGuide { 
  0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7); } 
  70% { transform: scale(1); box-shadow: 0 0 0 8px rgba(16, 185, 129, 0); } 
  100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); } 
}

/* 🎯 FIX: VERIFIED NOW टिकर के स्मूथ ग्लो एनीमेशन के लिए नया रुल */
@keyframes pulseGlow {
  0% { transform: scale(1); opacity: 0.6; }
  70% { transform: scale(1.1); opacity: 1; }
  100% { transform: scale(1); opacity: 0.6; }
}
.smart-guide-target {
  box-shadow: 0 0 0 4px #10B981, 0 0 20px #10B981 !important;
  outline: 3px solid white !important;
  background-color: #fff !important; 
  color: #000 !important;
  transition: all 0.3s ease !important;
  position: relative !important;
  z-index: 9999999 !important;
  pointer-events: auto !important;
}

/* 👇 COLOR FIXES 👇 */
.force-white { color: white !important; }
.force-green { color: #10B981 !important; }
.force-blue-text { color: #2563EB !important; }
.force-grey { color: #64748B !important; }
.force-red { color: #ed2222ff !important; }

/* 🌟 NAYA: Smart Guide On hone par Post Job ka text aur icon Black ho jaye 🌟 */
.smart-guide-target .force-white { color: #000 !important; }
.smart-guide-target svg { stroke: #000 !important; color: #000 !important; }

/* 🌟 NAYA: PREMIUM SCROLLBAR STYLING 🌟 */
.premium-scroll::-webkit-scrollbar {
  height: 4px;
}
.premium-scroll::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
}
.premium-scroll::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2); 
  border-radius: 10px;
}
.premium-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.4); 
}

`;
document.head.appendChild(styleTag);

const Vacancies = ({ user, appBg, globalGuide }) => {
  // --- SMART GUIDE INITIALIZATION ---
 const {
      voiceAssist, showGuideModal, setShowGuideModal,
      activeGuideFlow, currentGuideMessage,
      toggleVoiceAssist, handleVoiceClick,
      startSmartGuide, endSmartGuide, advanceNextStep,
      speakHinglish /* 👇 बस यह एक नाम यहाँ जोड़ना था */
  } = globalGuide;
  const [activeTab, setActiveTab] = useState('my_jobs');
  const [myVacancies, setMyVacancies] = useState([]);
  const [allVacancies, setAllVacancies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [boardLoading, setBoardLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  
  const [customRole, setCustomRole] = useState('');
  const [ownerDefaults, setOwnerDefaults] = useState({ location: '', mobile: '', textile_name: '' });
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [myJobsFilter, setMyJobsFilter] = useState('active'); // NAYA: Active/Closed filter toggle ke liye
  
  // Custom Delete Modal State
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);
  
  const jobRoles = ['Loom Worker', 'Loom Mukadam', 'Rach Worker', 'Metha Worker', 'Taration Worker', 'Sweeper', 'Other'];
  const categories = ['All', ...jobRoles];

  const [formData, setFormData] = useState({
    role: '', salary: '', vacanciesCount: '', 
    experience: 'Fresher', description: '', location: '', contactNumber: ''
  });

  const appBgFinal = appBg || localStorage.getItem('appBg') || "url('/OHOME.jpg') center / cover no-repeat fixed";

 useEffect(() => {
    const fetchOwnerDetails = async () => {
        try {
            const res = await fetch(`${API_BASE}/get_explore_jobs.php?action=get_all_open`);
            const json = await res.json();
            if (json.status === 'success' && json.data) {
                // 🌟 FIX: API का नेस्टेड स्ट्रक्चर ब्रेक करके सही ऑब्जेक्ट्स निकाले
                const bus = json.data.business_details || {};
                const owner = json.data.owner_details || {};
                
                const details = {
                    location: bus.textile_address || '', 
                    mobile: owner.mobile || '',
                    textile_name: bus.textile_name || '' // 🎯 यहाँ से "Raees Textile" परफेक्ट लोड होगा!
                };
                setOwnerDefaults(details);
                
                setFormData(prev => ({
                    ...prev,
                    location: prev.location || details.location,
                    contactNumber: prev.contactNumber || details.mobile
                }));
            }
        } catch (e) { console.error("Failed to fetch owner profile", e); }
    };
    fetchOwnerDetails();
  }, []);

  const fetchMyVacancies = async () => {
    setLoading(true);
    try {
      const ownerId = user?.id || 1; 
      const res = await fetch(`${API_BASE}/vacancies_api.php?action=get_my_vacancies&owner_id=${ownerId}`);
      const json = await res.json();
      if (json.status === 'success') { setMyVacancies(json.data); } 
      else { setMyVacancies([]); }
    } catch (error) { console.error("Failed to fetch my vacancies", error); }
    setLoading(false);
  };

const fetchAllOpenVacancies = async () => {
    setBoardLoading(true);
    try {
        const res = await fetch(`${API_BASE}/get_explore_jobs.php?action=get_all_open`);
        const json = await res.json();
        
        if (json.status === 'success') { 
            // डेटाबेस से आने वाली सभी जॉब्स को सेट कर देंगे
            setAllVacancies(json.data); 
        } else { 
            setAllVacancies([]); 
        }
    } catch (error) { 
        console.error("Failed to connect to explore jobs API:", error); 
        setAllVacancies([]); 
    }
    setBoardLoading(false);
  };

  useEffect(() => { 
      if (activeTab === 'my_jobs') fetchMyVacancies();
      else fetchAllOpenVacancies();
  }, [activeTab]);

  const handleInputChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  // --- EDIT AND DELETE LOGIC ---
  const openEditForm = (vac) => {
    const roleExists = jobRoles.some(r => r.trim() === vac.role.trim());
    setFormData({
        id: vac.id,
        role: roleExists ? jobRoles.find(r => r.trim() === vac.role.trim()) : 'Other',
        salary: vac.salary,
        vacanciesCount: vac.vacanciesCount,
        experience: vac.experience,
        description: vac.description,
        location: vac.location,
        contactNumber: vac.contactNumber
    });
    if (!roleExists) setCustomRole(vac.role);
    setShowForm(true);
  };

  // Naya function: Closed job ko nayi job ki tarah open karne ke liye
  const reopenJobAsNew = (vac) => {
    const roleExists = jobRoles.some(r => r.trim() === vac.role.trim());
    setFormData({
        id: null, // ID ko null rakha gaya hai taaki ye Nayi Job (add_vacancy) bane
        role: roleExists ? jobRoles.find(r => r.trim() === vac.role.trim()) : 'Other',
        salary: vac.salary,
        vacanciesCount: vac.vacanciesCount,
        experience: vac.experience,
        description: vac.description,
        location: vac.location,
        contactNumber: vac.contactNumber
    });
    if (!roleExists) setCustomRole(vac.role);
    setShowForm(true); // Form open ho jayega
  };

  

  // ओपन कस्टम डिलीट अलर्ट
  const handleDelete = (id) => {
    setDeleteConfirmId(id);
  };

  // कन्फर्म डिलीट
  const confirmDelete = async () => {
    if (!deleteConfirmId) return;
    try {
        const res = await fetch(`${API_BASE}/vacancies_api.php`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ action: 'delete_vacancy', id: deleteConfirmId })
        });
        const json = await res.json();
        if (json.status === 'success') {
            fetchMyVacancies();
            setDeleteConfirmId(null); // Close the modal
        } else {
            alert("Error: " + json.message);
        }
    } catch (err) { console.error("Delete failed", err); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Strict Validation: In 5 fields ke bina job post aage nahi badhega
    if (!formData.role || !formData.salary || !formData.vacanciesCount || !formData.location || !formData.contactNumber) {
        alert(" कृपया सभी ज़रूरी जानकारी भरें (Job Role, Salary, Openings, Location, Mobile Number).");
        return;
    }

    const finalRole = formData.role === 'Other' ? customRole.trim() : formData.role.trim();

    if (formData.role === 'Other' && !finalRole) {
        alert("Please enter the custom job role.");
        return;
    }

 const payload = { 
    ...formData, 
    role: finalRole, 
    experience: formData.experience || 'Fresher', 
    owner_id: user?.id || 1, 
    textile_name: ownerDefaults.textile_name || '', // 🎯 phpMyAdmin के नए कॉलम के लिए कारखाने का नाम भेजा
    location: formData.location, // लोकेशन को क्लीन रखा ताकि नाम मिक्स न हो
    action: formData.id ? 'update_vacancy' : 'add_vacancy' 
};
    
    try {
        const res = await fetch(`${API_BASE}/vacancies_api.php`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        const text = await res.text();
        try {
            const json = JSON.parse(text);
            if (json.status === 'success') {
                alert(formData.id ? "Job Updated Successfully!" : "Vacancy Posted Successfully!");
                fetchMyVacancies();
                setShowForm(false);
                // Yahan role ko wapas khali kiya gaya hain
                setFormData({ 
                    role: '', salary: '', vacanciesCount: '', experience: 'Fresher', 
                    description: '', location: ownerDefaults.location, contactNumber: ownerDefaults.mobile 
                });
                setCustomRole('');
            } else { alert("Error: " + json.message); }
        } catch (e) { console.error("Server Raw Response:", text); }
    } catch (err) { alert("Network Error: Could not connect to server."); }
  };

 const toggleStatus = async (id, currentStatus) => {
    // String ko clean kar rahe hain taaki extra space ka masla na rahe
    const safeStatus = String(currentStatus).trim();
    const newStatus = safeStatus === 'Open' ? 'Closed' : 'Open';
    
    try {
        const res = await fetch(`${API_BASE}/vacancies_api.php`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ action: 'update_status', id, status: newStatus })
        });
        const text = await res.text();
        try {
            const json = JSON.parse(text);
            if(json.status === 'success') { 
                fetchMyVacancies(); 
            } else {
                alert("Error: " + json.message);
            }
        } catch (e) { console.error("Server Raw Response:", text); }
    } catch (err) { alert("Network Error: Could not connect to server."); }
  };

 const filteredAllJobs = useMemo(() => {
    return allVacancies.filter(job => {
        // Space hatane ke liye trim add kiya hai
        const safeJobRole = String(job.role || '').trim();
        const safeCategory = selectedCategory.trim();
        const safeSearch = searchQuery.trim().toLowerCase();

        const matchesSearch = safeJobRole.toLowerCase().includes(safeSearch) || 
                              String(job.location || '').toLowerCase().includes(safeSearch);
                              
        // Yahan dono variables ko trim karke match kar rahe hain
        const matchesCategory = selectedCategory === 'All' || safeJobRole === safeCategory;
        
        return matchesSearch && matchesCategory;
    });
  }, [allVacancies, searchQuery, selectedCategory]);

  const getHindiCatName = (catName) => {
      const name = catName.trim();
      if (name === 'All') return ' ऑल';
      if (name === 'Loom Worker') return ' लूम वर्कर';
      if (name === 'Loom Mukadam') return ' लूम मुकादम';
      if (name === 'Rach Worker') return ' रछ वर्कर';
      if (name === 'Metha Worker') return ' मेथा वर्कर';
      if (name === 'Taration Worker') return ' तराशन वर्कर';
      if (name === 'Other') return ' अन्य';
      return name;
  };

// --- NAYA CODE: My Postings ke liye Active aur Closed ka count aur filter nikalna ---
  const activeMyJobsCount = myVacancies.filter(vac => String(vac.status).trim() === 'Open').length;
  const closedMyJobsCount = myVacancies.length - activeMyJobsCount;

  // Jo filter select kiya hai, sirf wahi jobs dikhane ka logic
  const displayedMyJobs = myVacancies.filter(vac => {
      const isOpen = String(vac.status).trim() === 'Open';
      return myJobsFilter === 'active' ? isOpen : !isOpen;
  });

   // 🌟 NAYA LOGIC: Check all Vacancies Modals
  const isAnyModalOpen = showGuideModal || showForm || deleteConfirmId;

  // ===== 🌟 PREMIUM SCROLL LOCK (Hostinger / Mobile Fix) 🌟 =====
  useEffect(() => {
      if (isAnyModalOpen) {
          document.body.style.overflow = 'hidden'; 
      } else {
          document.body.style.overflow = 'auto';   
      }
      return () => { document.body.style.overflow = 'auto'; };
  }, [isAnyModalOpen]);

  return (
    <div style={styles.container}>
      
  {/* ===== 🌟 PREMIUM HEADER (Matched exactly with Workers.js) 🌟 ===== */}
      <div style={{...styles.header, background: '#ffffff', borderBottom: '1px solid #e2e8f0', boxShadow: '0 4px 15px rgba(0,0,0,0.03)', zIndex: activeGuideFlow ? 20 : 1000}}>
          <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
              {/* Workers.js जैसा सेम बॉक्स साइज़ और पैडिंग */}
              <div style={{background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0', padding: '4px', display:'flex', alignItems:'center', boxShadow: '0 2px 4px rgba(0,0,0,0.02)'}}>
                  <Briefcase size={16} color="#475569"/>
              </div>
              <div>
                  <h1 style={{fontSize:'16px', fontWeight:'900', color:'#0F172A', margin:0, letterSpacing:'-0.5px'}}>Job Openings</h1>
                  <div style={{fontSize:'8px', color:'#64748B', fontWeight:'800', marginTop:'2px', letterSpacing:'0.5px', textTransform:'uppercase'}}>
                      Manage & Explore
                  </div>
              </div>
          </div>
          
          {/* Workers.js जैसा 6px का गैप */}
          <div style={{display:'flex', gap:'6px'}}>
              
              {/* 🌟 FIX: Global 14px !important को बायपास करने के लिए और भी कॉम्पैक्ट क्लास 🌟 */}
              <style>{`.header-compact-text { font-size: 8px !important; font-weight: 900 !important; letter-spacing: 0.3px !important; }`}</style>

              {/* Smart Guide Button - Exact Match with Workers.js */}
              <button 
                  onClick={() => {
                      speakHinglish(" Smart Live Guide Menu ओपन हो गया है, आप किस Topic के बारे में सीखना चाहते हैं? नीचे दिए गए options में से चुनें, 1. अपने टेक्सटाइल कारखाने के लिए New Job Vacancy कैसे Post करें? ");
                      setShowGuideModal(true);
                  }} 
                  style={{
                      padding: '6px 8px', borderRadius: '10px',
                      background: 'linear-gradient(135deg, #E0F2FE, #7DD3FC)', border: '1px solid #BAE6FD',
                      boxShadow: '0 2px 6px rgba(2, 132, 199, 0.15)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', transition: 'all 0.2s'
                  }}
              >
                  <HelpCircle size={14} color="#0284C7"/>
              </button>

            {activeTab === 'my_jobs' && (
                  // Post Job Button - Exact Match with Workers.js 'Add' button size
                  <button id="btn-post-job" className="header-compact-text" onClick={(e) => handleVoiceClick(e, " यह पोस्ट जॉब बटन है, इससे आप अपने टेक्सटाइल कारखाने में नए वर्कर्स के लिए वेकेंसी डाल सकते हैं।", () => {
                      setFormData({ role: '', salary: '', vacanciesCount: '', experience: 'Fresher', description: '', location: ownerDefaults.location, contactNumber: ownerDefaults.mobile });
                      setCustomRole('');
                      setShowForm(true);
                  }, 'btn-post-job')} style={{
                      padding: '4px 8px', borderRadius: '8px',
                      background: 'linear-gradient(135deg, #D1FAE5, #6EE7B7)', color: '#047857', border: '1px solid #A7F3D0',
                      boxShadow: '0 2px 6px rgba(16, 185, 129, 0.15)',
                      display: 'flex', alignItems: 'center', gap: '4px',
                      cursor: 'pointer', transition: 'all 0.25s ease'
                  }}>
                      <Plus size={10} color="#047857" style={{flexShrink: 0}} /> <span className="header-compact-text">POST JOB</span>
                  </button>
              )}
          </div>
      </div>

      <div style={styles.content}>
        
        {/* ==========================================
            🌟 UNIFIED CONTROL CENTER (TABS + FILTERS) 🌟
        ========================================== */}
        <div style={{ 
            background: 'linear-gradient(135deg, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0.65) 100%)', 
            backdropFilter: 'blur(24px)', 
            borderRadius: '24px', 
            padding: '12px', 
            boxShadow: '0 10px 25px rgba(0,0,0,0.04), inset 0 2px 0 rgba(255,255,255,1)', 
            border: '1px solid rgba(255,255,255,0.7)',
            marginBottom: '16px',
            display: 'flex',         /* 🌟 Parent-Child को कनेक्ट करने के लिए */
            flexDirection: 'column', /* 🌟 एक के नीचे एक अलाइन करने के लिए */
            gap: '8px'               /* 🌟 दोनों के बीच का गैप कम कर दिया है */
        }}>
            {/* 🌟 MAIN TABS (PARENT STRIP): MY POSTINGS / EXPLORE JOBS 🌟 */}
            <div style={{ 
                display: 'flex', 
                background: '#F1F5F9', 
                padding: '4px', 
                borderRadius: '16px', 
                boxShadow: 'inset 0 2px 5px rgba(0,0,0,0.05)', 
                border: '1px solid rgba(226, 232, 240, 0.8)'
            }}>
                <button 
                    onClick={(e)=> handleVoiceClick(
                        e, 
                        " यह My Postings Button है, इसमें आपकी डाली गई सभी जॉब वेकेंसी दिखेंगी,", 
                        () => setActiveTab('my_jobs'), 
                        'tab-my-jobs', 
                        activeTab === 'my_jobs', 
                        " आप अभी My Postings Button में हैं, यहाँ नीचे आपको वो सारी जॉब्स दिख रही हैं जो आपने आपने टेक्सटाइल कारखाने के लिए डाली हैं।"
                    )} 
                    style={activeTab === 'my_jobs' 
                        ? { flex: 1, padding: '8px 12px', background: '#FFFFFF', border: '1px solid rgba(0,0,0,0.04)', borderRadius: '12px', fontWeight: '600', color: '#0F172A', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', cursor: 'pointer', transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)', fontSize: '11px', textTransform: 'uppercase', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' } 
                        : { flex: 1, padding: '8px 12px', background: 'transparent', border: '1px solid transparent', borderRadius: '12px', fontWeight: '600', color: '#64748B', cursor: 'pointer', transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)', fontSize: '11px', textTransform: 'uppercase', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}
                >
                    <div style={{ background: activeTab === 'my_jobs' ? 'linear-gradient(135deg, #D1FAE5, #6EE7B7)' : 'transparent', padding: '4px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: activeTab === 'my_jobs' ? '0 2px 6px rgba(5, 150, 105, 0.2)' : 'none', transition: 'all 0.2s' }}>
                        <Briefcase size={14} color={activeTab === 'my_jobs' ? '#047857' : '#94A3B8'}/>
                    </div>
                    MY POSTINGS
                </button>
                <button 
                    onClick={(e)=> handleVoiceClick(
                        e, 
                        " यह एक्सप्लोर जॉब्स Button है, इसमें आप अपनी डाली हुई जॉब वेकेंसी और दूसरे टेक्सटाइल कारखानों में कौन-सी जॉब वेकेंसीज़ निकली हैं देख सकते हैं,", 
                        () => setActiveTab('all_jobs'), 
                        'tab-all-jobs', 
                        activeTab === 'all_jobs', 
                        " आप अभी एक्सप्लोर जॉब्स Button में हैं, यहाँ नीचे आप अपनी डाली हुई जॉब वेकेंसी और दूसरे टेक्सटाइल कारखानों में कौन-सी जॉब वेकेंसीज़ निकली हैं देख सकते हैं।"
                    )} 
                    style={activeTab === 'all_jobs' 
                        ? { flex: 1, padding: '8px 12px', background: '#FFFFFF', border: '1px solid rgba(0,0,0,0.04)', borderRadius: '12px', fontWeight: '600', color: '#0F172A', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', cursor: 'pointer', transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)', fontSize: '11px', textTransform: 'uppercase', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' } 
                        : { flex: 1, padding: '8px 12px', background: 'transparent', border: '1px solid transparent', borderRadius: '12px', fontWeight: '600', color: '#64748B', cursor: 'pointer', transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)', fontSize: '11px', textTransform: 'uppercase', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}
                >
                    <div style={{ background: activeTab === 'all_jobs' ? 'linear-gradient(135deg, #E0F2FE, #7DD3FC)' : 'transparent', padding: '4px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: activeTab === 'all_jobs' ? '0 2px 6px rgba(2, 132, 199, 0.2)' : 'none', transition: 'all 0.2s' }}>
                        <Search size={14} color={activeTab === 'all_jobs' ? '#0369A1' : '#94A3B8'}/>
                    </div>
                    EXPLORE JOBS
                </button>
            </div>

            {/* 🌟 SUB-TABS (CHILD STRIP): ACTIVE / CLOSED JOBS 🌟 */}
            {activeTab === 'my_jobs' && !loading && myVacancies.length > 0 && (
                <div style={{ 
                    display: 'flex', 
                    background: 'rgba(241, 245, 249, 0.6)', /* 🌟 Parent से थोड़ा हल्का कलर */
                    padding: '3px', /* 🌟 Padding कम की गई है ताकि छोटा लगे */
                    borderRadius: '12px', /* 🌟 Radius कम किया गया है (Child Shape) */
                    boxShadow: 'inset 0 2px 5px rgba(0,0,0,0.03)', 
                    border: '1px solid rgba(226, 232, 240, 0.5)',
                    margin: '0 8px' /* 🌟 Left-Right margin दिया ताकि यह Parent के मुक़ाबले छोटा दिखे */
                }}>
                    <button 
                        onClick={(e) => handleVoiceClick(e, `अभी आपकी ${activeMyJobsCount} जॉब्स ओपन हैं।`, () => setMyJobsFilter('active'), 'filter-active')}
                        style={myJobsFilter === 'active' 
                            ? { flex: 1, padding: '6px 10px', background: '#FFFFFF', border: '1px solid rgba(0,0,0,0.03)', borderRadius: '10px', fontWeight: '600', color: '#0F172A', boxShadow: '0 2px 6px rgba(0,0,0,0.06)', cursor: 'pointer', transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)', fontSize: '10px', textTransform: 'uppercase', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '6px' } 
                            : { flex: 1, padding: '6px 10px', background: 'transparent', border: '1px solid transparent', borderRadius: '10px', fontWeight: '600', color: '#64748B', cursor: 'pointer', transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)', fontSize: '10px', textTransform: 'uppercase', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '6px' }}
                    >
                        <div style={{ background: myJobsFilter === 'active' ? 'linear-gradient(135deg, #D1FAE5, #6EE7B7)' : 'transparent', padding: '3px', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: myJobsFilter === 'active' ? '0 2px 4px rgba(5, 150, 105, 0.15)' : 'none', transition: 'all 0.2s' }}>
                            <CheckCircle size={12} color={myJobsFilter === 'active' ? '#047857' : '#94A3B8'}/>
                        </div>
                        ACTIVE ({activeMyJobsCount})
                    </button>
                    
                    <button 
                        onClick={(e) => handleVoiceClick(e, `आपकी ${closedMyJobsCount} जॉब्स क्लोज हो चुकी हैं।`, () => setMyJobsFilter('closed'), 'filter-closed')}
                        style={myJobsFilter === 'closed' 
                            ? { flex: 1, padding: '6px 10px', background: '#FFFFFF', border: '1px solid rgba(0,0,0,0.03)', borderRadius: '10px', fontWeight: '600', color: '#0F172A', boxShadow: '0 2px 6px rgba(0,0,0,0.06)', cursor: 'pointer', transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)', fontSize: '10px', textTransform: 'uppercase', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '6px' } 
                            : { flex: 1, padding: '6px 10px', background: 'transparent', border: '1px solid transparent', borderRadius: '10px', fontWeight: '600', color: '#64748B', cursor: 'pointer', transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)', fontSize: '10px', textTransform: 'uppercase', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '6px' }}
                    >
                        <div style={{ background: myJobsFilter === 'closed' ? 'linear-gradient(135deg, #FEE2E2, #FCA5A5)' : 'transparent', padding: '3px', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: myJobsFilter === 'closed' ? '0 2px 4px rgba(220, 38, 38, 0.15)' : 'none', transition: 'all 0.2s' }}>
                            <XCircle size={12} color={myJobsFilter === 'closed' ? '#B91C1C' : '#94A3B8'}/>
                        </div>
                        CLOSED ({closedMyJobsCount})
                    </button>
                </div>
            )}
        </div>

        {activeTab === 'my_jobs' && (
            <>
                {/* MY JOBS LIST */}
                <div style={{display:'flex', flexDirection:'column', gap:'12px'}}>
                  {loading ? <p style={{textAlign:'center', color:'#111', fontSize:'12px', fontWeight:   '600'}}>Loading...</p> : 
                   displayedMyJobs.length === 0 ? (
                       <div style={{textAlign:'center', padding:'20px', color:'#111', background:'rgba(255,255,255,0.4)', borderRadius:'16px', border:'1px solid rgba(255,255,255,0.5)'}}>
                           <p style={{fontSize:'12px', fontWeight:'600', margin:0}}>
                               {myJobsFilter === 'active' ? 'No active jobs right now.' : 'No closed jobs found.'}
                           </p>
                       </div>
                   ) :
                   displayedMyJobs.map((vac) => {
 
 const safeStatus = String(vac.status).trim(); 
 const isJobOpen = safeStatus === 'Open';
 const statusText = isJobOpen ? 'Open' : 'Closed';
 const salaryText = vac.salary ? `${vac.salary} रुपये हफ्ते की सैलरी` : ' तय नहीं';
 
 const expVal = String(vac.experience || '').trim().toLowerCase();
 const displayExperience = (expVal === '' || expVal === '0' || expVal === 'fresher' || expVal === 'no') ? 'Fresher' : `${vac.experience} Years`;
 const expText = displayExperience === 'Fresher' ? 'कोई नहीं' : displayExperience;
 
 const expVoiceMessage = displayExperience === 'Fresher' ? ' एक्सपीरियंस नहीं भी है तो चलेगा' : ` एक्सपीरियंस ${vac.experience} साल का होना चाहिए`;
 const descText = vac.description ? ` description, ${vac.description}` : '';
 const hindiVacname = getHindiCatName(vac.role);
 
 let jobVoiceSummary = '';
 if (isJobOpen) {
     jobVoiceSummary = ` यह आपकी जॉब पोस्ट है, जो अभी ओपन है, इसमें ${vac.vacanciesCount}, ${hindiVacname} की ज़रूरत है, आपने ${salaryText} रखी है, और ${expVoiceMessage}, यह जॉब का address ${vac.location} है। ${descText}`;
 } else {
     jobVoiceSummary = ` यह आपकी जॉब पोस्ट थी, जो अभी क्लोज्ड है, इसमें ${vac.vacanciesCount}, ${hindiVacname} की ज़रूरत थी, आपने ${salaryText} रखी थी, and ${expVoiceMessage}, यह जॉब का address ${vac.location} था। ${descText}`;
 }

return (
 <div 
     key={vac.id} 
     onClick={(e) => handleVoiceClick(e, jobVoiceSummary, null, `card-my-job-${vac.id}`)}
     style={{
         background: isJobOpen ? 'rgba(255, 255, 255, 0.78)' : 'rgba(241, 245, 249, 0.45)', 
         backdropFilter: 'blur(30px) saturate(200%)',
         WebkitBackdropFilter: 'blur(30px) saturate(200%)',
         borderRadius: '28px', 
         padding: '20px',
         boxShadow: isJobOpen 
            ? '0 20px 40px rgba(15, 23, 42, 0.04), inset 0 1px 1px rgba(255,255,255,1)' 
            : 'none', 
         border: isJobOpen ? '1px solid rgba(255,255,255,0.6)' : '1px solid rgba(226, 232, 240, 0.4)',
         marginBottom: '16px', 
         position: 'relative',
         overflow: 'hidden',
         opacity: isJobOpen ? 1 : 0.55, 
         filter: isJobOpen ? 'none' : 'grayscale(30%)',
         cursor: 'pointer',
         transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
     }}
 >
   {/* Elegant Atmospheric Glow Blobs */}
   {isJobOpen && (
       <>
           <div style={{ position: 'absolute', top: '-60px', right: '-60px', width: '130px', height: '140px', background: 'radial-gradient(circle, #34D399 0%, transparent 70%)', opacity: 0.12, filter: 'blur(24px)', pointerEvents: 'none' }} />
           <div style={{ position: 'absolute', bottom: '-60px', left: '-60px', width: '130px', height: '140px', background: 'radial-gradient(circle, #38BDF8 0%, transparent 70%)', opacity: 0.08, filter: 'blur(24px)', pointerEvents: 'none' }} />
       </>
   )}

   {/* Top Header Row */}
   <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start', borderBottom:'1px solid rgba(15, 23, 42, 0.05)', paddingBottom:'14px', marginBottom:'14px', zIndex: 1, position: 'relative'}}>
     <div>
       <span style={{fontSize: '10px', mountaineer: '900', fontWeight: '900', color: '#64748B', textTransform: 'uppercase', marginBottom: '6px', display: 'block', letterSpacing:'0.8px'}}>Required Role</span>
       <div style={{background: '#FFFFFF', border: '1px solid #E2E8F0', padding: '6px 14px', borderRadius: '12px', display: 'inline-flex', alignItems: 'center', gap: '8px', marginBottom: '6px', boxShadow: '0 2px 6px rgba(15, 23, 42, 0.02)'}}>
          <span style={{fontSize: '16px', lineHeight: 1}}>💼</span>
          <h3 style={{color:'#0F172A', fontSize:'14px', fontWeight:'900', margin:0, letterSpacing: '-0.3px'}}>{vac.role}</h3>
       </div>
       <div style={{fontSize: '11px', color:'#64748B', display:'flex', alignItems:'center', gap:'12px', fontWeight:'700'}}>
           <span style={{display:'flex', alignItems:'center', gap:'4px'}}><Clock size={12} color="#94A3B8"/> {vac.dateAdded}</span>
           <span style={{display:'flex', alignItems:'center', gap:'4px'}}><Users size={12} color="#94A3B8"/> {vac.vacanciesCount} Openings</span>
       </div>
     </div>
     
     <div style={{display:'flex', alignItems:'center', gap: '8px'}}>
         <button onClick={(e) => { e.stopPropagation(); handleVoiceClick(e, " यह एडिट बटन है...", () => openEditForm(vac), `btn-edit-${vac.id}`); }} style={{ background: '#FFFFFF', border: '1px solid #E2E8F0', borderRadius: '10px', padding: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 6px rgba(0,0,0,0.025)', transition: 'all 0.2s' }}>
             <Edit size={14} color="#2563EB"/>
         </button>
         <button onClick={(e) => { e.stopPropagation(); handleVoiceClick(e, " यह डिलीट बटन है...", () => handleDelete(vac.id), `btn-delete-${vac.id}`); }} style={{ background: '#FFFFFF', border: '1px solid #E2E8F0', borderRadius: '10px', padding: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 6px rgba(0,0,0,0.025)', transition: 'all 0.2s' }}>
             <Trash2 size={14} color="#DC2626"/>
         </button>
         <span style={{padding:'5px 12px', borderRadius:'10px', fontSize:'10px', fontWeight:'900', background: isJobOpen ? 'linear-gradient(135deg, #D1FAE5, #A7F3D0)' : '#E2E8F0', color: isJobOpen ? '#047857' : '#475569', display:'inline-flex', alignItems:'center', gap:'4px', letterSpacing: '0.5px'}}>
             {isJobOpen ? <CheckCircle size={11} strokeWidth={2.5}/> : <XCircle size={11} strokeWidth={2.5}/>} {statusText.toUpperCase()}
         </span>
     </div>
   </div>
   
   {/* Fintech Style Metrics Grid */}
   <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px', marginBottom:'14px', zIndex: 1, position: 'relative'}}>
       
       {/* Salary Box */}
       <div style={{ background: '#FFFFFF', border: '1px solid #F1F5F9', padding: '14px', borderRadius: '18px', display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 4px 12px rgba(15, 23, 42, 0.015)' }}>
           <div style={{ background: 'linear-gradient(135deg, #059669, #10B981)', padding: '8px', borderRadius: '12px', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(5, 150, 105, 0.2)' }}><IndianRupee size={16}/></div>
           <div style={{ display: 'flex', flexDirection: 'column' }}>
               <span style={{fontSize:'10px', color:'#64748B', fontWeight:'800', textTransform:'uppercase', letterSpacing:'0.5px'}}>Weekly Salary</span>
               <span style={{fontSize:'15px', fontWeight:'900', color: '#16A34A', letterSpacing: '-0.3px'}}>₹{vac.salary}/wk</span>
           </div>
       </div>

       {/* Experience Box */}
       <div style={{ background: '#FFFFFF', border: '1px solid #F1F5F9', padding: '14px', borderRadius: '18px', display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 4px 12px rgba(15, 23, 42, 0.015)' }}>
           <div style={{ background: 'linear-gradient(135deg, #0284C7, #38BDF8)', padding: '8px', borderRadius: '12px', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(2, 132, 199, 0.15)' }}><Briefcase size={16}/></div>
           <div style={{ display: 'flex', flexDirection: 'column' }}>
               <span style={{fontSize:'10px', color:'#64748B', fontWeight: '800', textTransform:'uppercase', letterSpacing:'0.5px'}}>Experience</span>
               <span style={{fontSize:'15px', fontWeight:'900', color: '#0F172A', letterSpacing: '-0.3px'}}>{displayExperience}</span>
           </div>
       </div>

       {/* LOCATION STAT BOX (FULL WIDTH) */}
<div style={{ gridColumn: '1 / -1', background: '#FFFFFF', border: '1px solid #F1F5F9', padding: '14px', borderRadius: '18px', display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 4px 12px rgba(15, 23, 42, 0.015)' }}>
    <div style={{ background: 'linear-gradient(135deg, #D97706, #FBBF24)', padding: '8px', borderRadius: '12px', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(217, 119, 6, 0.15)' }}><MapPin size={16}/></div>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{fontSize:'9px !important', color:'#64748B', fontWeight:'800', textTransform:'uppercase', letterSpacing:'0.5px'}}>Job Location</span>
        <span style={{fontSize:'13px !important', fontWeight:'800', color: '#334155', marginTop:'2px', lineHeight: '1.4'}}>{vac.location}</span>
    </div>
</div>
   </div>
   
   <span style={{fontSize: '10px', fontWeight: '800', color: '#64748B', textTransform: 'uppercase', marginBottom: '6px', display: 'block', letterSpacing:'0.5px', paddingLeft: '4px'}}>Description</span>
   <p style={{fontSize:'13px', color:'#475569', lineHeight:'1.6', background:'rgba(15, 23, 42, 0.02)', padding:'12px 16px', borderRadius:'16px', margin:'0 0 16px 0', fontWeight:'700', border:'1px solid rgba(15, 23, 42, 0.03)'}}>{vac.description}</p>
   
   {/* Bottom Strip */}
   <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', paddingTop:'14px', borderTop:'1px solid rgba(15, 23, 42, 0.05)', zIndex: 1, position: 'relative'}}>
       <span style={{fontSize:'13px', fontWeight:'900', color:'#0F172A', display:'flex', alignItems: 'center', gap:'6px'}}><Phone size={14} color="#64748B"/> {vac.contactNumber}</span>
       <button onClick={(e) => { e.stopPropagation(); handleVoiceClick(e, " इस बटन से...", () => isJobOpen ? toggleStatus(vac.id, safeStatus) : reopenJobAsNew(vac), `btn-toggle-status-${vac.id}`); }} 
       style={{
           padding: '8px 16px', 
           borderRadius: '12px', 
           fontSize: '11px', 
           fontWeight: '900', 
           cursor: 'pointer', 
           transition: 'all 0.2s',
           border: 'none',
           textTransform: 'uppercase',
           letterSpacing: '0.3px',
           background: isJobOpen ? 'linear-gradient(135deg, #FEF3C7, #FDE68A)' : 'linear-gradient(135deg, #D1FAE5, #6EE7B7)',
           color: isJobOpen ? '#B45309' : '#047857',
           boxShadow: isJobOpen ? '0 4px 12px rgba(217, 119, 6, 0.1)' : '0 4px 12px rgba(16, 185, 129, 0.1)'
       }}>
         {isJobOpen ? 'Close Job' : 'Re-open'}
       </button>
   </div>
 </div>
)})
                  }
                </div>
            </>
        )}

       {activeTab === 'all_jobs' && (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        
        {/* Native Premium Engine Style Overrides */}
        <style>{`
            .luxury-glass-hub {
                background: rgba(255, 255, 255, 0.72) !important;
                backdrop-filter: blur(30px) saturate(200%) !important;
                -webkit-backdrop-filter: blur(30px) saturate(200%) !important;
                border: 1px solid rgba(255, 255, 255, 0.6) !important;
                box-shadow: 0 20px 48px rgba(15, 23, 42, 0.05), inset 0 1px 1px rgba(255, 255, 255, 1) !important;
                border-radius: 32px !important;
            }
            .interactive-search-bar {
                border: 1px solid #E2E8F0 !important;
                transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;
            }
            .interactive-search-bar:focus-within {
                border-color: #0F172A !important;
                box-shadow: 0 0 0 4px rgba(15, 23, 42, 0.08), 0 4px 12px rgba(15, 23, 42, 0.02) !important;
                background: #FFFFFF !important;
            }
            .micro-click-pill {
                transition: all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
            }
            .micro-click-pill:active {
                transform: scale(0.94) !important;
            }
            .ultra-clean-scroll::-webkit-scrollbar {
                display: none !important;
            }
            .ultra-clean-scroll {
                -ms-overflow-style: none !important;
                scrollbar-width: none !important;
            }
        `}</style>

        {/* ==========================================
            🌟 THE WORLD-CLASS UNIFIED CONTROL CENTER 🌟
        ========================================== */}
        <div className="luxury-glass-hub" style={{ 
            padding: '18px', 
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            position: 'relative',
            overflow: 'hidden'
        }}>
            {/* Elegant Atmospheric Light Diffusion Blobs */}
            <div style={{ position: 'absolute', top: '-50px', left: '-50px', width: '140px', height: '140px', background: 'radial-gradient(circle, #38BDF8 0%, transparent 75%)', opacity: 0.15, filter: 'blur(28px)', pointerEvents: 'none' }} />
            <div style={{ position: 'absolute', bottom: '-50px', right: '-50px', width: '140px', height: '140px', background: 'radial-gradient(circle, #34D399 0%, transparent 75%)', opacity: 0.15, filter: 'blur(28px)', pointerEvents: 'none' }} />

            {/* 1. DISCRETE SNEAK-PEEK INPUT ENGINE */}
            <div className="interactive-search-bar" style={{
                display: 'flex', 
                alignItems: 'center', 
                background: 'rgba(248, 250, 252, 0.6)', 
                borderRadius: '16px', 
                padding: '12px 16px',
                zIndex: 1
            }}>
                <Search size={18} color="#475569" style={{ flexShrink: 0, opacity: 0.8 }} />
                <input 
                    type="text" 
                    onClick={(e) => handleVoiceClick(e, " यहाँ से आप जॉब का नाम या लोकेशन के हिसाब से जॉब सर्च कर सकते हैं।", null)} 
                    placeholder="Search role, area or location..." 
                    style={{
                        border: 'none', 
                        background: 'transparent', 
                        outline: 'none', 
                        width: '100%', 
                        marginLeft: '12px', 
                        fontSize: '13.5px', 
                        color: '#0F172A', 
                        fontWeight: '700',
                        fontFamily: "'Plus Jakarta Sans', sans-serif"
                    }} 
                    value={searchQuery} 
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>
            
            {/* 2. HIGH-FURNISHED HORIZONTAL FILTER ENGINE */}
            <div className="ultra-clean-scroll" style={{ 
                display: 'flex', 
                gap: '10px', 
                overflowX: 'auto', 
                whiteSpace: 'nowrap', 
                paddingBottom: '2px', 
                margin: '0 -4px',
                WebkitOverflowScrolling: 'touch',
                zIndex: 1
            }}>
                {categories.map((cat) => {
                    const hindiCat = getHindiCatName(cat); 

                    const voiceMessage = cat === 'All' 
                        ? " यह ऑल का बटन है, इसपर क्लिक करने से आपको सभी तरह की जॉब्स एक साथ दिखेंगी।"
                        : ` यह ${hindiCat} की जॉब्स देखने का फ़िल्टर है, इसपर क्लिक करने से सिर्फ ${hindiCat} की वेकेंसी दिखेंगी।`;

                    const alreadySelectedMessage = cat === 'All'
                        ? " आपने पहले से ही ऑल चुना हुआ है, अभी स्क्रीन पर आपको सभी तरह की jobs एक साथ दिख रही हैं।"
                        : ` आपने पहले से ही ${hindiCat} का फ़िल्टर चुना हुआ है, अभी स्क्रीन पर आपको नीचे सिर्फ ${hindiCat} की ही जॉब्स दिख रही हैं।`;

                    const safeCatForCount = cat.trim();
                    const activeJobCount = cat === 'All' 
                        ? allVacancies.length 
                        : allVacancies.filter(job => String(job.role).trim() === safeCatForCount).length;

                    const isSelected = selectedCategory === cat;

                    return (
                        <button 
                            key={cat} 
                            className="micro-click-pill"
                            onClick={(e) => handleVoiceClick(
                                e, 
                                voiceMessage, 
                                () => setSelectedCategory(cat), 
                                `cat-${cat}`,
                                isSelected,
                                alreadySelectedMessage
                            )} 
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                padding: '10px 18px',
                                borderRadius: '100px',
                                fontSize: '12px',
                                fontWeight: '800',
                                cursor: 'pointer',
                                flexShrink: 0,
                                fontFamily: "'Plus Jakarta Sans', sans-serif",
                                position: cat === 'All' ? 'sticky' : 'static',
                                left: cat === 'All' ? '0px' : 'auto',
                                zIndex: cat === 'All' ? 20 : 1,
                                background: isSelected 
                                    ? (cat === 'All' ? 'linear-gradient(135deg, #0284C7, #38BDF8)' : '#0F172A') 
                                    : '#FFFFFF',
                                color: isSelected ? '#FFFFFF' : '#475569',
                                border: isSelected ? 'none' : '1px solid #E2E8F0',
                                boxShadow: isSelected 
                                    ? '0 8px 20px rgba(15, 23, 42, 0.16)' 
                                    : '0 2px 6px rgba(0,0,0,0.01)'
                            }}
                        >
                            {cat}
                            
                            <span 
                                style={{
                                    background: activeJobCount > 0 
                                        ? (isSelected ? 'rgba(255,255,255,0.25)' : '#10B981') 
                                        : (isSelected ? 'rgba(255,255,255,0.15)' : '#F1F5F9'), 
                                    color: activeJobCount > 0 || isSelected ? '#FFFFFF' : '#64748B',     
                                    padding: '3px 8px',
                                    borderRadius: '8px',
                                    fontSize: '9px',
                                    fontWeight: '900',
                                    boxShadow: activeJobCount > 0 && !isSelected ? '0 2px 6px rgba(16, 185, 129, 0.3)' : 'none',
                                    display: 'inline-block',
                                    lineHeight: '1'
                                }}
                            >
                                {activeJobCount}
                            </span>
                        </button>
                    )
                })}
            </div>

            {/* 3. PREMIUM FINTECH STYLE DATA TICKER STRIP */}
            {!boardLoading && filteredAllJobs.length > 0 && (
                <div style={{
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    padding: '12px 16px', 
                    background: 'rgba(15, 23, 42, 0.03)', 
                    borderRadius: '14px', 
                    border: '1px solid rgba(15, 23, 42, 0.02)',
                    zIndex: 1
                }}>
                    <span style={{ fontSize: '11px', fontWeight: '900', letterSpacing: '0.8px', textTransform: 'uppercase', color: '#334155' }}>
                        {filteredAllJobs.length} {filteredAllJobs.length === 1 ? 'Vacancy' : 'Vacancies'} Live
                    </span>
                    <span style={{ fontSize: '11px', color: '#059669', display: 'flex', alignItems: 'center', gap: '6px', fontWeight: '900', letterSpacing: '0.5px' }}>
                        <div style={{
                            width: '6px', 
                            height: '6px', 
                            borderRadius: '50%', 
                            background: '#10B981', 
                            boxShadow: '0 0 10px #10B981',
                            animation: 'pulseGlow 2s infinite'
                        }} /> 
                        VERIFIED NOW
                    </span>
                </div>
            )}
        </div>

                {/* 🌟 JOBS LISTING SECTION 🌟 */}
                {boardLoading ? (
                    <div style={{textAlign:'center', padding:'40px', color:'#111'}}><Clock size={24} color="#111" style={{marginBottom:'10px', animation:'spin 2s linear infinite'}}/><p style={{fontSize:'12px', fontWeight:'600'}}>Loading Jobs...</p></div>
                ) : filteredAllJobs.length === 0 ? (
                    <div style={{textAlign:'center', padding:'40px', color:'#111'}}><AlertCircle size={32} color="#111" style={{marginBottom:'10px', opacity:0.6}}/><h3 style={{fontSize:'15px', color:'#111', margin:'0 0 6px 0', fontWeight:'600'}}>No Jobs Found</h3><p style={{fontSize:'11px', fontWeight:'600', color:'#444'}}>Try selecting a different category.</p></div>
               ) : (
    <>
  {filteredAllJobs.map((job) => {
    const salaryText = job.salary ? `${job.salary} रुपये हफ्ते की सैलरी` : ' तय नहीं';    
    const expVal = String(job.experience || '').trim().toLowerCase();
    const displayExperience = (expVal === '' || expVal === '0' || expVal === 'fresher' || expVal === 'no') ? 'Fresher' : `${job.experience} Years`;
    
    const expVoiceMessage = displayExperience === 'Fresher' ? ' एक्सपीरियंस नहीं भी है तो चलेगा' : ` एक्सपीरियंस ${job.experience} साल का होना चाहिए`;
    const descText = job.description ? ` description, ${job.description},` : '';
    const hindiRoleName = getHindiCatName(job.role);

   // 🌟 FIX: ID मिसमैच से बचने के लिए ID के साथ-साथ मोबाइल नंबर को भी क्रॉस-वेरीफाई किया ताकि गड़बड़ का चांस ही न रहे
    const isMyOwnJob = Number(job.owner_id) === Number(user?.id || 1) || 
                       String(job.contactNumber).trim() === String(ownerDefaults.mobile).trim();
                       
    // 🎯 FIX: दूसरे यूजर्स की जॉब्स पर आपका नाम न दिखे, बल्कि डेटाबेस से पोस्ट करने वाले का सही नाम आए
    const displayFactoryName = job.textile_name || job.factory_name || (isMyOwnJob ? ownerDefaults.textile_name : "Textile Factory");
    const exploreJobVoiceSummary = ` यह जॉब, ${displayFactoryName} कारखाने में,${job.vacanciesCount}, ${hindiRoleName} की ज़रूरत हैं, इसके लिए ${salaryText} दी जाएंगी, and ${expVoiceMessage}, कारखाने का पता ${job.location} है, ${descText} और जानकारी के लिए, आप कॉल बटन दबाकर सीधे कारखाने के ओनर से बात कर सकते हैं।`;    return (
     <div 
         key={job.id} 
         onClick={(e) => handleVoiceClick(e, exploreJobVoiceSummary, null, `card-explore-job-${job.id}`)}
         style={{
             background: 'rgba(255, 255, 255, 0.75)', 
             backdropFilter: 'blur(24px) saturate(180%)',
             WebkitBackdropFilter: 'blur(24px) saturate(180%)',
             borderRadius: '28px', 
             padding: '20px',
             boxShadow: '0 16px 40px rgba(15, 23, 42, 0.04), inset 0 1px 1px rgba(255,255,255,1)', 
             border: '1px solid rgba(255,255,255,0.6)',
             marginBottom: '16px', 
             position: 'relative',
             overflow: 'hidden',
             cursor: 'pointer',
             transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
         }}
     >
       {/* High Aesthetics Vector Glows */}
       <div style={{ position: 'absolute', top: '-60px', right: '-60px', width: '140px', height: '140px', background: 'radial-gradient(circle, #38BDF8 0%, transparent 70%)', opacity: 0.12, filter: 'blur(24px)', pointerEvents: 'none' }} />
       <div style={{ position: 'absolute', bottom: '-60px', left: '-60px', width: '140px', height: '140px', background: 'radial-gradient(circle, #34D399 0%, transparent 70%)', opacity: 0.08, filter: 'blur(24px)', pointerEvents: 'none' }} />

       <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start', borderBottom:'1px solid rgba(15, 23, 42, 0.05)', paddingBottom:'14px', marginBottom:'14px', zIndex: 1, position: 'relative'}}>
            <div>
                <span style={{fontSize: '10px', fontWeight: '800', color: '#64748B', textTransform: 'uppercase', marginBottom: '6px', display: 'block', letterSpacing:'0.8px'}}>Required Role</span>
               <div style={{ background: '#ffffff', border: '1px solid #E2E8F0', padding: '6px 14px', borderRadius: '10px', display: 'inline-flex', alignItems: 'center', gap: '8px', marginBottom: '6px', boxShadow: '0 2px 4px rgba(0,0,0,0.01)'}}>
                    <span style={{fontSize: '16px', lineHeight: 1}}>💼</span>
                    <h3 style={{color:'#0F172A', fontSize:'14px', fontWeight:'900', margin:0, letterSpacing: '-0.3px'}}>{job.role}</h3>
                </div>
                
             <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px', marginTop: '4px'}}>
                    <span className="force-grey" style={{fontSize: '10px', fontWeight: '900', color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.5px'}}>IN</span>
                    <span style={{display:'flex', alignItems:'center', gap:'4px',  padding: '4px 10px', borderRadius: '8px', border: '1px solid #E2E8F0', background: '#FFFFFF', fontSize:'11px', color:'#0F172A', fontWeight:'700', boxShadow: '0 2px 4px rgba(0,0,0,0.01)'}}>
                        <Building size={12} color="#2563EB"/> {displayFactoryName} {/* 🌟 NAYA: Yahan humne job.factory_name ko dynamic displayFactoryName se badal diya */}
                    </span>
                    <span style={{display:'flex', alignItems:'center', gap:'4px', padding: '4px 10px', background: '#FEF3C7', borderRadius: '8px', fontSize:'11px', color:'#B45309', fontWeight:'700'}}>
                        <Users size={12} color="#D97706"/> {job.vacanciesCount} Openings
                    </span>
                </div>
             </div>
             <span className="force-red" style={{padding:'5px 12px', borderRadius:'10px', fontSize:'10px', fontWeight:'900', background:'linear-gradient(135deg, #FEE2E2, #FCA5A5)', color:'#DC2626', display:'inline-flex', alignItems:'center', border:'none', letterSpacing:'0.8px'}}>
                 URGENT
             </span>
         </div>

         {/* Widgets Grid */}
         <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px', marginBottom:'14px', zIndex: 1, position: 'relative'}}>
             
             {/* Salary Widget */}
             <div style={{ background: '#FFFFFF', border: '1px solid #F1F5F9', padding: '14px', borderRadius: '18px', display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 4px 12px rgba(15, 23, 42, 0.015)' }}>
                 <div style={{ background: 'linear-gradient(135deg, #059669, #10B981)', padding: '8px', borderRadius: '12px', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(5, 150, 105, 0.2)' }}><IndianRupee size={16}/></div>
                 <div style={{ display: 'flex', flexDirection: 'column' }}>
                     <span style={{fontSize:'10px', color:'#64748B', fontWeight:'800', textTransform:'uppercase', letterSpacing:'0.5px'}}>Weekly Salary</span>
                     <span style={{fontSize:'15px', fontWeight:'900', color: '#16A34A', letterSpacing: '-0.3px'}}>₹{job.salary}/wk</span>
                 </div>
             </div>

             {/* Experience Widget */}
             <div style={{ background: '#FFFFFF', border: '1px solid #F1F5F9', padding: '14px', borderRadius: '18px', display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 4px 12px rgba(15, 23, 42, 0.015)' }}>
                 <div style={{ background: 'linear-gradient(135deg, #0284C7, #38BDF8)', padding: '8px', borderRadius: '12px', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(2, 132, 199, 0.15)' }}><Briefcase size={16}/></div>
                 <div style={{ display: 'flex', flexDirection: 'column' }}>
                     <span style={{fontSize:'10px', color:'#64748B', fontWeight: '800', textTransform:'uppercase', letterSpacing:'0.5px'}}>Experience</span>
                     <span style={{fontSize:'15px', fontWeight:'900', color: '#0F172A', letterSpacing: '-0.3px'}}>{displayExperience}</span>
                 </div>
             </div>

            {/* LOCATION STAT BOX (FULL WIDTH) */}
<div style={{ gridColumn: '1 / -1', background: '#FFFFFF', border: '1px solid #F1F5F9', padding: '14px', borderRadius: '18px', display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 4px 12px rgba(15, 23, 42, 0.015)' }}>
    <div style={{ position: 'absolute', top: '-15px', right: '-15px', width: '55px', height: '55px', background: 'radial-gradient(circle, #FCD34D 0%, transparent 70%)', opacity: 0.15, filter: 'blur(12px)', borderRadius: '50%' }} />
    <div style={{ background: 'linear-gradient(135deg, #D97706, #FBBF24)', padding: '8px', borderRadius: '12px', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(217, 119, 6, 0.15)' }}><MapPin size={16}/></div>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{fontSize:'9px !important', color:'#64748B', fontWeight:'800', textTransform:'uppercase', letterSpacing:'0.5px'}}>Job Location</span>
        <span style={{fontSize:'13px !important', fontWeight:'800', color: '#334155', marginTop:'2px', lineHeight: '1.4'}}>{job.location}</span>
    </div>
</div>
         </div>

         <span style={{fontSize: '10px', fontWeight: '800', color: '#64748B', textTransform: 'uppercase', marginBottom: '6px', display: 'block', letterSpacing:'0.5px', paddingLeft: '4px'}}>Description</span>
         <div style={{background:'rgba(15, 23, 42, 0.02)', padding:'12px 16px', borderRadius:'16px', border:'1px solid rgba(15, 23, 42, 0.03)', marginBottom:'14px'}}>
             <p style={{fontSize:'13px', color:'#475569', margin:0, lineHeight:'1.6', fontWeight:'700'}}>{job.description}</p>
         </div>

         {/* Bottom Action Strip */}
         <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', paddingTop:'14px', borderTop:'1px solid rgba(15, 23, 42, 0.05)', zIndex: 1, position: 'relative'}}>
             <span className="force-grey" style={{fontSize:'12px', fontWeight:'700', color:'#64748B', display:'flex', alignItems:'center', gap:'6px'}}><Clock size={12} color="#94A3B8"/> Posted: {job.dateAdded}</span>
            <button onClick={(e) => { e.stopPropagation(); handleVoiceClick(e, " इस कॉल बटन से...", () => window.open(`tel:${job.contactNumber}`, '_self'), `btn-call-${job.id}`); }} style={{ ...styles.primaryBtn, background: '#0F172A', color: '#FFFFFF', border: 'none', padding: '10px 20px', borderRadius: '14px', fontSize: '13px', fontWeight: '900', gap: '6px', minHeight: 'auto', boxShadow: '0 8px 20px rgba(15, 23, 42, 0.16)', transition: 'all 0.2s', display: 'flex', alignItems: 'center' }}>
                <PhoneCall size={14} className="force-white" strokeWidth={2.5} /> <span className="force-white" style={{fontSize: '13px', fontWeight:'900'}}>Call Now</span>
            </button>
         </div>
     </div>
    )
})}
                    </>
                )}
            </div>
        )}
      </div>

  {/* ===== 🌟 MASTER-CLASS HIGH LEVEL GLASSMORPHISM JOB FORM MODAL 🌟 ===== */}
      <Modal 
          isOpen={showForm} 
          onClose={() => {
              if(window.speechSynthesis) window.speechSynthesis.cancel();
              setShowForm(false);
          }}
          title={formData.id ? 'Edit Job Post' : 'Post New Job'} 
          icon={Briefcase} 
          iconColor="#047857" 
          iconBg="linear-gradient(135deg, #D1FAE5, #6EE7B7)"
          maxWidth="450px"
      >
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', height: '100%', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              
              {/* 🌟 LUXURY FROSTED GLASS HUB PANEL (HIGH-LEVEL GLASSMORPHISM) 🌟 */}
              <div style={{
                  background: 'rgba(255, 255, 255, 0.55)',
                  backdropFilter: 'blur(30px) saturate(210%)',
                  WebkitBackdropFilter: 'blur(30px) saturate(210%)',
                  borderRadius: '30px',
                  padding: '20px',
                  border: '1px solid rgba(255, 255, 255, 0.65)',
                  boxShadow: '0 24px 50px rgba(15, 23, 42, 0.06), inset 0 1px 2px rgba(255, 255, 255, 1)',
                  position: 'relative',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '14px',
                  marginTop: '12px'
              }}>
                  {/* High Definition Ambient Light Diffusion Blobs */}
                  <div style={{ position: 'absolute', top: '-40px', right: '-40px', width: '150px', height: '150px', background: 'radial-gradient(circle, #38BDF8 0%, transparent 70%)', opacity: 0.18, filter: 'blur(26px)', pointerEvents: 'none' }} />
                  <div style={{ position: 'absolute', bottom: '-40px', left: '-40px', width: '150px', height: '150px', background: 'radial-gradient(circle, #34D399 0%, transparent 70%)', opacity: 0.15, filter: 'blur(26px)', pointerEvents: 'none' }} />

                  {/* MASTER GRID CONTROLLER */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', zIndex: 1, position: 'relative' }}>
                      
                      {/* 1. JOB ROLE WIDGET */}
                      <div style={{ background: '#FFFFFF', border: '1px solid #E2E8F0', padding: '12px', borderRadius: '18px', display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 4px 12px rgba(15, 23, 42, 0.015)' }}>
                          <div style={{ background: 'linear-gradient(135deg, #0284C7, #38BDF8)', padding: '8px', borderRadius: '12px', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(2, 132, 199, 0.15)', flexShrink: 0 }}><Briefcase size={16}/></div>
                          <div style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
                              <span style={{ fontSize: '9px', fontWeight: '800', color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Job Role</span>
                              <select 
                                  id="input-job-role" 
                                  name="role" 
                                  value={formData.role} 
                                  onClick={(e) => handleVoiceClick(e, " किस काम के लिए वर्कर चाहिए? लिस्ट में से चुनें, अगर लिस्ट में नाम नहीं है तो Other चुनें।", null)} 
                                  onChange={handleInputChange} 
                                  style={{ width: '100%', border: 'none', background: 'transparent', outline: 'none', fontSize: '13.5px', color: '#0F172A', fontWeight: '800', marginTop: '2px', padding: 0, cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif" }} 
                                  required
                              >
                                  <option value="" disabled>Select Role</option>
                                  {jobRoles.map((r, i) => <option key={i} value={r.trim()}>{r.trim()}</option>)}
                              </select>
                          </div>
                      </div>

                      {/* 2. WEEKLY SALARY WIDGET */}
                      <div style={{ background: '#FFFFFF', border: '1px solid #E2E8F0', padding: '12px', borderRadius: '18px', display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 4px 12px rgba(15, 23, 42, 0.015)' }}>
                          <div style={{ background: 'linear-gradient(135deg, #059669, #10B981)', padding: '8px', borderRadius: '12px', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(5, 150, 105, 0.2)', flexShrink: 0 }}><IndianRupee size={16}/></div>
                          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                              <span style={{ fontSize: '9px', fontWeight: '800', color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Weekly Salary</span>
                              <input 
                                  id="input-job-salary" 
                                  type="number" 
                                  name="salary" 
                                  value={formData.salary} 
                                  onClick={(e) => handleVoiceClick(e, " वर्कर को आप हफ्ते की कितनी पगार देंगे? वो यहाँ लिखें।", null)} 
                                  onChange={handleInputChange} 
                                  placeholder="e.g. 4000" 
                                  style={{ width: '100%', border: 'none', background: 'transparent', outline: 'none', fontSize: '13.5px', color: '#0F172A', fontWeight: '800', marginTop: '2px', padding: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }} 
                                  required 
                              />
                          </div>
                      </div>

                    {/* CONDITIONAL CUSTOM ROLE ENGINE (TRIM PROTECTED & HIGH VISIBILITY) */}
                      {String(formData.role).trim() === 'Other' && (
                          <div style={{ gridColumn: '1 / -1', background: '#FFFFFF', border: '1px solid #E2E8F0', padding: '14px', borderRadius: '18px', display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 4px 12px rgba(15, 23, 42, 0.015)', animation: 'fadeIn 0.25s ease' }}>
                              <div style={{ background: 'linear-gradient(135deg, #D97706, #FBBF24)', padding: '8px', borderRadius: '12px', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(217, 119, 6, 0.15)', flexShrink: 0 }}><Edit size={16}/></div>
                              <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                  <span style={{ fontSize: '9px', fontWeight: '800', color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Specify Custom Job Role Name</span>
                                  <input 
                                      type="text" 
                                      value={customRole} 
                                      onClick={(e) => handleVoiceClick(e, " यहाँ अपनी मनपसंद जॉब का नाम टाइप करें।", null)} 
                                      onChange={(e) => setCustomRole(e.target.value)} 
                                      placeholder="E.g. Supervisor, Loom Manager, Guard..." 
                                      style={{ width: '100%', border: 'none', background: 'transparent', outline: 'none', fontSize: '13.5px', color: '#0F172A', fontWeight: '800', marginTop: '3px', padding: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }} 
                                      required 
                                  />
                              </div>
                          </div>
                      )}

                      {/* 3. OPENINGS WIDGET */}
                      <div style={{ background: '#FFFFFF', border: '1px solid #E2E8F0', padding: '12px', borderRadius: '18px', display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 4px 12px rgba(15, 23, 42, 0.015)' }}>
                          <div style={{ background: 'linear-gradient(135deg, #D97706, #FBBF24)', padding: '8px', borderRadius: '12px', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(217, 119, 6, 0.15)', flexShrink: 0 }}><Users size={16}/></div>
                          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                              <span style={{ fontSize: '9px', fontWeight: '800', color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Openings</span>
                              <input 
                                  id="input-job-openings" 
                                  type="number" 
                                  name="vacanciesCount" 
                                  value={formData.vacanciesCount} 
                                  onClick={(e) => handleVoiceClick(e, " आपको कितने वर्कर्स की ज़रूरत है? वो लिखें।", null)} 
                                  onChange={handleInputChange} 
                                  placeholder="2" 
                                  style={{ width: '100%', border: 'none', background: 'transparent', outline: 'none', fontSize: '13.5px', color: '#0F172A', fontWeight: '800', marginTop: '2px', padding: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }} 
                                  required 
                              />
                          </div>
                      </div>

                      {/* 4. EXPERIENCE WIDGET */}
                      <div style={{ background: '#FFFFFF', border: '1px solid #E2E8F0', padding: '12px', borderRadius: '18px', display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 4px 12px rgba(15, 23, 42, 0.015)' }}>
                          <div style={{ background: 'linear-gradient(135deg, #0284C7, #38BDF8)', padding: '8px', borderRadius: '12px', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(2, 132, 199, 0.15)', flexShrink: 0 }}><Clock size={16}/></div>
                          <div style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
                              <span style={{ fontSize: '9px', fontWeight: '800', color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Experience</span>
                              <select 
                                  id="input-job-experience" 
                                  name="experience" 
                                  value={formData.experience || 'Fresher'} 
                                  onClick={(e) => handleVoiceClick(e, " वर्कर को इस काम का कितने साल का Experience होना चाहिए? वो लिस्ट में से चुनें।", null)} 
                                  onChange={handleInputChange} 
                                  style={{ width: '100%', border: 'none', background: 'transparent', outline: 'none', fontSize: '13.5px', color: '#0F172A', fontWeight: '800', marginTop: '2px', padding: 0, cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif" }}
                              >
                                  <option value="Fresher">Fresher</option>
                                  {Array.from({ length: 50 }, (_, i) => i + 1).map(num => (
                                      <option key={num} value={num}>{num} {num === 1 ? 'Year' : 'Years'}</option>
                                  ))}
                              </select>
                          </div>
                      </div>

                     {/* 5. DYNAMIC FULL-WIDTH LOCATION ENGINE (AUTO-FILLED & EDITABLE) */}
<div style={{ gridColumn: '1 / -1', background: '#FFFFFF', border: '1px solid #E2E8F0', padding: '14px', borderRadius: '18px', display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 4px 12px rgba(15, 23, 42, 0.015)' }}>
    <div style={{ background: 'linear-gradient(135deg, #E11D48, #F43F5E)', padding: '8px', borderRadius: '12px', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(225, 29, 72, 0.15)', flexShrink: 0 }}><MapPin size={16}/></div>
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <span style={{ fontSize: '9px', fontWeight: '800', color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Job Location</span>
        <input 
            id="input-job-location" 
            type="text" 
            name="location" 
            value={formData.location} 
            onClick={(e) => handleVoiceClick(e, " यहाँ काम की जगह का Address लिखें, ओनर प्रोफ़ाइल से आपका पता पहले से यहाँ भरा हुआ है, आप चाहें तो इसे बदल भी सकते हैं।", null)} 
            onChange={handleInputChange} 
            placeholder="Enter complete job address area..." 
            style={{ width: '100%', border: 'none', background: 'transparent', outline: 'none', fontSize: '13.5px', color: '#0F172A', fontWeight: '800', marginTop: '3px', padding: 0, fontFamily: "'Plus Jakarta Sans', sans-serif", textOverflow: 'clip' }} 
            required 
        />
    </div>
</div>

                      {/* 6. DYNAMIC FULL-WIDTH MOBILE ENGINE */}
                      <div style={{ gridColumn: '1 / -1', background: '#FFFFFF', border: '1px solid #E2E8F0', padding: '14px', borderRadius: '18px', display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 4px 12px rgba(15, 23, 42, 0.015)' }}>
                          <div style={{ background: 'linear-gradient(135deg, #2563EB, #60A5FA)', padding: '8px', borderRadius: '12px', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(37, 99, 235, 0.15)', flexShrink: 0 }}><Phone size={16}/></div>
                          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                              <span style={{ fontSize: '9px', fontWeight: '800', color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Contact Mobile Number</span>
                              <input 
                                  id="input-job-mobile" 
                                  type="tel" 
                                  name="contactNumber" 
                                  value={formData.contactNumber} 
                                  onClick={(e) => handleVoiceClick(e, " अपना मोबाइल नंबर डालें ताकि वर्कर सीधा आपको कॉल कर सके।", null)} 
                                  onChange={handleInputChange} 
                                  placeholder="Enter 10-digit number" 
                                  style={{ width: '100%', border: 'none', background: 'transparent', outline: 'none', fontSize: '13.5px', color: '#0F172A', fontWeight: '800', marginTop: '3px', padding: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }} 
                                  required 
                              />
                          </div>
                      </div>

                      {/* 7. DESCRIPTION WIDGET */}
                      <div style={{ gridColumn: '1 / -1', background: '#FFFFFF', border: '1px solid #E2E8F0', padding: '14px', borderRadius: '18px', display: 'flex', alignItems: 'flex-start', gap: '12px', boxShadow: '0 4px 12px rgba(15, 23, 42, 0.015)' }}>
                          <div style={{ background: 'linear-gradient(135deg, #475569, #94A3B8)', padding: '8px', borderRadius: '12px', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(71, 85, 105, 0.15)', flexShrink: 0 }}><Edit size={16}/></div>
                          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                              <span style={{ fontSize: '9px', fontWeight: '800', color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Description</span>
                              <textarea 
                                  id="input-job-description" 
                                  name="description" 
                                  value={formData.description} 
                                  onClick={(e) => handleVoiceClick(e, " जॉब के बारे में कोई और ज़रूरी जानकारी या नियम यहाँ लिखें, जैसे: रहने की सुविधा है या नहीं, या कुछ और. ", null)} 
                                  onChange={handleInputChange} 
                                  placeholder="Write extra details or shift timings here..." 
                                  style={{ width: '100%', border: 'none', background: 'transparent', outline: 'none', fontSize: '13.5px', color: '#0F172A', fontWeight: '800', marginTop: '4px', padding: 0, height: '75px', resize: 'none', fontFamily: "'Plus Jakarta Sans', sans-serif" }} 
                              />
                      </div>
                  </div>

                  </div>

                  {/* High Quality Notice Ticker */}
                  <div style={{ background: 'rgba(245, 158, 11, 0.06)', border: '1px solid rgba(245, 158, 11, 0.15)', padding: '12px 14px', borderRadius: '14px', display: 'flex', alignItems: 'center', gap: '10px', zIndex: 1, position: 'relative' }}>
                      <AlertCircle size={15} color="#D97706" style={{ flexShrink: 0 }} />
                      <p style={{ fontSize: '11px', color: '#B45309', margin: '0', fontWeight: '700', letterSpacing: '-0.1px' }}>
                          This vacancy post will live on the board and expire automatically in 7 days.
                      </p>
                  </div>

              </div>

            {/* 👇 STICKY BOTTOM ACTION ENGINE (PERFECT CORNER SYNCED GLASS) 👇 */}
<div style={{ 
    marginTop: '16px', 
    position: 'sticky', 
    bottom: '-20px', 
    paddingBottom: '20px', 
    paddingLeft: '20px',
    paddingRight: '20px',
    margin: '0 -20px -20px -20px', /* 🌟 PANEL BOUNDARIES FLUSH TRICK */
    background: 'rgba(255, 255, 255, 0.65)', 
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    borderTop: '1px solid rgba(15, 23, 42, 0.06)', 
    paddingTop: '14px', 
    zIndex: 10,
    borderRadius: '0 0 30px 30px' /* 🌟 MATCHES EXACTLY WITH PARENT DIALOG CURVE */
}}>
    <button 
        id="btn-save-job" 
        type="submit" 
        onClick={(e) => handleVoiceClick(e, " पब्लिश jobb पोस्ट बटन से आप अपनी वेकेंसी को लाइव कर सकते हैं, ध्यान दें: यह पोस्ट 7 दिन बाद अपने आप डिलीचे हो जाएगी।", null, 'btn-save-job')} 
        className="micro-click-pill"
        style={{
            width: '100%', 
            padding: '14px', 
            background: 'linear-gradient(135deg, #10B981, #059669)', 
            color: '#FFFFFF', 
            border: 'none', 
            borderRadius: '16px', 
            fontWeight: '900', 
            cursor: 'pointer', 
            fontSize: '13.5px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            gap: '8px', 
            boxShadow: '0 8px 24px rgba(16, 185, 129, 0.25)',
            letterSpacing: '0.3px',
            textTransform: 'uppercase'
        }}
    >
        <CheckCircle size={16} color="white" strokeWidth={3}/>
        {formData.id ? 'UPDATE JOB POST' : 'PUBLISH JOB POST'}
    </button>
</div>
          </form>
      </Modal>

     {/* --- CUSTOM DELETE CONFIRMATION MODAL --- */}
      <ConfirmModal 
          isOpen={!!deleteConfirmId} 
          onClose={() => setDeleteConfirmId(null)} 
          onConfirm={(e) => {
              handleVoiceClick(e, " यह डिलीट कन्फर्म बटन है, इससे जॉब हमेशा के लिए डिलीट हो जाएगी।", confirmDelete, 'btn-confirm-delete');
          }} 
          message="क्या आप वाकई इस जॉब पोस्ट को हमेशा के लिए डिलीट करना चाहते हैं? यह वापस नहीं आएगा।"
          title="Delete Job Post?"
          isDanger={true}
          confirmText="Delete"
      />

      {/* ===== 🌟 PREMIUM SMART GUIDE MODAL 🌟 ===== */}
      <Modal
          isOpen={showGuideModal}
          onClose={() => {
              if (window.speechSynthesis) {
                  window.speechSynthesis.pause();
                  window.speechSynthesis.cancel();
              }
              setShowGuideModal(false);
          }}
          title="Smart Live Guide"
          icon={HelpCircle}
          maxWidth="430px"
      >
          <div>
              <p style={{fontSize:'10px', fontWeight:'600', color:'#64748B', marginBottom:'16px', textTransform: 'uppercase', letterSpacing: '0.5px'}}>Aap kis topic ke bare me sikhna chahte hain? Niche Diye Gaye Options Me Se Chune.</p>
              
              <div style={{display:'flex', flexDirection:'column', gap:'12px'}}>
                  <div onClick={(e) => {
                      setShowGuideModal(false);
                      handleVoiceClick(e, " ये नया जॉब पोस्ट करने का गाइड है।", () => startSmartGuide('add_vacancy'), 'guide-add-vacancy');
                  }} style={{display: 'flex', justifyContent: 'space-between', padding: '12px', alignItems: 'center', background: '#f8fafc', borderRadius: '16px', cursor: 'pointer', border: '1px solid #e2e8f0', transition: 'all 0.2s'}}>
                      <span style={{fontSize:'11px', fontWeight:'600', color:'#0F172A'}}>1) Apne Textile Karkhane Ke Liye New Job Vacancy Kaise Post Kare?</span>
                      <div style={{ background: 'linear-gradient(135deg, #E0E7FF, #A5B4FC)', padding: '6px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(79, 70, 229, 0.15)', flexShrink: 0 }}>
                          <PlayCircle size={16} color="#4338CA"/>
                      </div>
                  </div>
              </div>
          </div>
      </Modal>

      

      

    </div>
  );
};

// --- STYLES OBJECT ---
const styles = {
  container: { 
      zoom: 0.95,
      fontSize: '14px',
      minHeight: '100vh', 
      width: '100%', 
      height: '100%', 
      position: 'fixed',                  /* स्क्रीन को एक जगह फिक्स करेगा */
      top: 0, 
      left: 0, 
      overflowY: 'auto',                  /* स्क्रॉलिंग अब सिर्फ इसके अंदर होगी */
      overflowX: 'hidden', 
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      WebkitOverflowScrolling: 'touch',
      overscrollBehaviorY: 'contain',
                  
  },
  
  header: { background: 'rgba(255, 255, 255, 0.25)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)', padding: '12px 16px', borderBottom: '1px solid rgba(255, 255, 255, 0.2)', display: 'flex', alignItems: 'center', justifyContent:'space-between', position:'sticky', top:0, zIndex: 10, transform: 'translateZ(0)' },  
  tabsContainer: { display: 'flex', background: 'rgba(255,255,255,0.4)', padding: '4px', borderRadius: '16px', marginBottom: '16px', border:'1px solid rgba(255,255,255,0.5)', boxShadow:'0 4px 12px rgba(0,0,0,0.05)' },
  activeTab: { flex: 1, padding: '10px', background: 'rgba(255,255,255,0.9)', border: 'none', borderRadius: '14px', fontSize: '11px', fontWeight: '600', color: '#111', cursor: 'pointer', boxShadow: '0 4px 10px rgba(0,0,0,0.1)', transition: 'all 0.2s' },
  inactiveTab: { flex: 1, padding: '10px', background: 'transparent', border: 'none', borderRadius: '14px', fontSize: '11px', fontWeight: '600', color: '#444', cursor: 'pointer', transition: 'all 0.2s' },
  
  content: { padding: '16px', paddingBottom: '90px', maxWidth: '600px', margin: '0 auto' },
  
  card: { 
      background: '#ffffff', borderRadius: '20px', padding: '16px', 
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.04)', border: '1px solid #e2e8f0', 
      marginBottom: '14px', position: 'relative',
      
      /* 🚀 BEHTREEN PERFORMANCE UPGRADE (GPU ACCELERATION) 🚀 */
      contentVisibility: 'auto',
      containIntrinsicSize: '250px',
      contain: 'paint layout',
      willChange: 'transform, opacity',
      transform: 'translateZ(0)',
      WebkitFontSmoothing: 'antialiased'
  },
  cardBox: { background: '#ffffff', padding: '12px', borderRadius: '16px', border: '1px solid #f1f5f9', boxShadow: '0 4px 10px rgba(0,0,0,0.02)', margin: 0 },
  cardBoxGrid: { background: '#ffffff', padding: '12px', borderRadius: '16px', border: '1px solid #f1f5f9', boxShadow: '0 4px 10px rgba(0,0,0,0.02)', margin: 0 },
  row: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  label: { fontSize: '9px', fontWeight: '600', color: '#111', textTransform: 'uppercase', marginBottom: '6px', display: 'block', letterSpacing:'0.5px' },
  input: { width: '100%', padding: '12px', borderRadius: '14px', border: '1px solid rgba(255,255,255,0.4)', fontSize: '12px', outline: 'none', background: 'rgba(255,255,255,0.6)', color:'#111', fontWeight:'500'      , boxSizing: 'border-box', transition:'background 0.2s', ':focus':{background:'rgba(255,255,255,0.9)'} },
  
  primaryBtnHeader: { display:'flex', alignItems:'center', gap:'6px', background: '#1A1A1A', color: 'white', border: 'none', padding: '8px 14px', borderRadius: '12px', fontSize: '11px', fontWeight: '600', cursor: 'pointer', boxShadow:'0 4px 12px rgba(0,0,0,0.2)' },
  primaryBtn: { display:'flex', alignItems:'center', gap:'6px', background: '#1A1A1A', color: 'white', border: 'none', padding: '10px 16px', borderRadius: '16px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', boxShadow:'0 4px 16px rgba(0,0,0,0.2)' },
  outlineBtn: { padding: '8px 14px', borderRadius: '12px', fontSize: '10px', fontWeight: '600', cursor: 'pointer', border: '1px solid', background:'transparent', transition:'all 0.2s' },
  infoBadge: { display:'flex', alignItems:'center', gap:'10px', background:'#ffffff', padding:'10px 12px', borderRadius:'12px', border:'1px solid #f1f5f9', boxShadow:'0 4px 10px rgba(0,0,0,0.02)' },
  iconBtn: { background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  
  searchBox: { display: 'flex', alignItems: 'center', background: 'rgba(255,255,255,0.4)', borderRadius: '16px', padding: '10px 14px', border: '1px solid rgba(255,255,255,0.5)', marginBottom: '12px', backdropFilter:'blur(10px)', boxShadow:'0 4px 12px rgba(0,0,0,0.05)' },
  searchInput: { border: 'none', background: 'transparent', outline: 'none', width: '100%', marginLeft: '10px', fontSize: '13px', color: '#111', fontWeight:'500'      , '::placeholder': {color:'#555'} },
 submitBtn: { 
      padding: '14px', 
      /* 👇 टॉप आइकन जैसा प्रीमियम ग्रीन ग्रेडिएंट */
      background: 'linear-gradient(135deg, #adfbd3ff, #5cebb1ff)', 
      /* 👇 डार्क ग्रीन टेक्स्ट कलर */
      color: '#026146ff', 
      border: '1px solid #A7F3D0', 
      borderRadius: '14px', 
      fontWeight: '600', 
      cursor: 'pointer', 
      fontSize:'13px', 
      /* 👇 मैचिंग ग्रीन शैडो/ग्लो */
      boxShadow: '0 6px 16px rgba(1, 188, 126, 0.25)', 
      transition: 'all 0.2s ease', 
      letterSpacing: '0.5px', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      gap: '8px' 
  },
    categoryStrip: { display: 'flex', gap: '8px', overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '6px', marginBottom:'12px', WebkitOverflowScrolling: 'touch' },
  activeChip: { background: 'linear-gradient(135deg, #E0F2FE, #7DD3FC)', color: '#0284C7', border: 'none', padding: '8px 16px', borderRadius: '100px', fontSize: '11px', fontWeight: '600', cursor: 'pointer', flexShrink: 0, boxShadow:'0 4px 10px rgba(2, 132, 199, 0.25)' },
  inactiveChip: { background: 'rgba(255,255,255,0.4)', color: '#111', border: '1px solid rgba(255,255,255,0.3)', padding: '8px 16px', borderRadius: '100px', fontSize: '11px', fontWeight: '600', cursor: 'pointer', flexShrink: 0, backdropFilter:'blur(10px)' },

};

export default Vacancies;